



























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Button from '@/components/WebView/Button.vue'
import vClickOutside from 'v-click-outside'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'

@Component<AlertDialog>({
    components: {PortalContainer, Button},
    directives: {
        clickOutside: vClickOutside.directive
    }
})
export default class AlertDialog extends Vue {
    @Prop({type: Boolean, default: false}) public show!: boolean
    @Prop({type: Boolean, default: false}) public allowClickOut!: boolean
    @Prop({type: String, default: 'Are you sure?'}) public title!: string
    @Prop({type: String, default: ''}) public message!: string
    @Prop({type: String, default: 'OK'}) public okTitle!: string
    @Prop({type: String, default: 'Cancel'}) public cancelTitle!: string
    @Prop({type: Function, default: () => 0}) public onCancel!: () => void
    @Prop({type: Function, default: () => 0}) public onOk!: () => void

    public clickOut(e) {
        if (!this.allowClickOut) {
            return
        }
        this.onCancel()
    }
}
